import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ListingColumn } from './data-table.interface';

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrl: './data-table.component.scss'
})
export class DataTableComponent implements OnInit, AfterViewInit, OnChanges {
  @Input() dataSource: any[] = [];
  @Input() headers!: ListingColumn[];
  @Input() scrollHeight?: string;
  @Output() selectedRow = new EventEmitter<string>();
  @Input() parentFunctionPaging?: (item: any) => void;
  @Input() rowClickFunction?: (item: any) => void;
  @Input() first?: number;
  @Input() listCount?: number;
  @Input() minHeight?: { id?: string, val?: string };
  @Output() onSearchValue = new EventEmitter<string>();

  fixedColumnHeader!: ListingColumn;
  visibleColumns: ListingColumn[] = [];
  currentColumnPage: number = 0;
  columnPages: number[] = [];
  hasMoreColumns: boolean = false;
  dynamicColumns: ListingColumn[] = [];
  dataTable: any;
  selected: any;

  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    this.setupColumns();
    this.loadDataSource();
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();

    setTimeout(() => {
      if (!this.listCount) {
        this.listingItemCount(this.dataSource.length);
      } else {
        this.listingItemCount(this.listCount);
      }

      if (this.minHeight?.id) {
        document
          .getElementById(this.minHeight.id)
          ?.querySelector('.p-datatable-wrapper')
          ?.setAttribute('style', `min-height:${this.minHeight.val}`);
      }

      if (!this.first) this.first = 0;
      if (!this.scrollHeight) this.scrollHeight = '550px';
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['headers']) {
      this.setupColumns();
    }

    if (changes['headers'] || changes['dataSource']) {
      this.loadDataSource();
    }
  }

  setupColumns() {
    const indexColumn = { value: 'index', label: 'No', sort: false, filter: false };
    const filteredHeaders = this.headers.filter((header) => header.value !== 'index');
  
    this.fixedColumnHeader = filteredHeaders[0];
    this.visibleColumns = filteredHeaders.filter((header) => header !== this.fixedColumnHeader);

    this.dataSource = this.dataSource.map((item, idx) => ({ ...item, index: idx + 1 }));
  }

  changeColumnPage(page: number) {
    const pageSize = 5;
    this.currentColumnPage = page;
    const start = page * pageSize;
    const end = start + pageSize;

    this.visibleColumns = this.dynamicColumns.slice(start, end);
  }

  paginate(item: any) {
    if (this.parentFunctionPaging) {
      this.parentFunctionPaging(item);
    }
  }

  loadDataSource() {
    this.dataTable = this.dataSource;
  }

  sortData(field: string, order: 'asc' | 'desc') {
    this.dataTable = [...this.dataTable].sort((a, b) => {
      if (a[field] < b[field]) return order === 'asc' ? -1 : 1;
      if (a[field] > b[field]) return order === 'asc' ? 1 : -1;
      return 0;
    });
  }

  filterData(field: string, value: string) {
    this.dataTable = this.dataSource.filter((item) =>
      item[field].toLowerCase().includes(value.toLowerCase())
    );
  }

  onRowSelect(event: any) {
    this.selectedRow.emit(this.selected);
  }

  rowClicked(row: any) {
    if (this.rowClickFunction) {
      this.rowClickFunction(row);
    }
  }

  listingItemCount(count: number) {
    if (this.dataSource.length > 4) {
      const element: HTMLElement | null = document.querySelector('.p-paginator .p-dropdown');
      if (element) {
        element.style.cssText = `--value-tasklist: "out of ${count} items"`;
      }
    }
  }
}